export const environmentMapping: {[key: string]: {[key: string]: string}} = {
  production: {
    topLevelDomain: 'com',
    protocol: 'https'
  },
  staging: {
    topLevelDomain: 'cn',
    protocol: 'https'
  },
  development: {
    topLevelDomain: 'cn',
    protocol: 'https'
  },
  test: {
    topLevelDomain: 'test',
    protocol: 'http'
  }
};
